import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageUrlGuid from '../../component/pageUrlGuid'
import Seperator from '../../component/seperator'
import { useNavigate } from 'react-router'
//third party
import { useSelector, useDispatch } from 'react-redux'

const Dashboard = ({ children }) => {
    
    const user = useSelector((state) => state.user)
    const location=useLocation()
    const navigate=useNavigate()
    
    const handleLogOut=()=>{
        navigate("/logOut")
    }
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    حساب کاربری
                </h1>
            </PageUrlGuid>
            <div className='dashboard'>
                <div className='menu-dashboard-container'>
                    <div className='menu-dashboard'>
                        <div className='header'>
                            <h3>{user.value.username}</h3>
                            <i className='fa fa-power-off' onClick={()=>handleLogOut()}></i>
                        </div>
                        <div className='body'>
                            <Link to={"/dashboard"}>
                                <div className={`${location.pathname=="/dashboard" ? "items active" : "items"}`}>
                                    <h2 >تکمیل و نمایش اطلاعات</h2>
                                    <i className='fa fa-info' ></i>
                                </div>
                            </Link>
                            <Link to={"/dashboard/myWebinars"}>
                                <div className={`${location.pathname=="/dashboard/myWebinars" ? "items active" : "items"}`}>
                                    <h2 >وبینار های من</h2>
                                    <i className='fas fa-microphone-alt' ></i>
                                </div>
                            </Link>
                            <Link to={"/dashboard/myFiles"}>
                                <div className={`${location.pathname=="/dashboard/myFiles" ? "items active" : "items"}`}>
                                    <h2 >ویدیو و فایل های من</h2>
                                    <i className='fas fa-folder' ></i>
                                </div>
                            </Link>
                            <Link to={"/dashboard/cTest"}>
                                <div className={`${location.pathname=="/dashboard/cTest" ? "items active" : "items"}`}>
                                    <h2 >گردونه شانس</h2>
                                    <i className='fas fa-bullseye' ></i>
                                </div>
                            </Link>
                            <Link to={"/dashboard/eTest"}>
                                <div className={`${location.pathname=="/dashboard/eTest" ? "items active" : "items"}`}>
                                    <h2 >آزمون های من</h2>
                                    <i className='fas fa-question' ></i>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className='content'>
                    {children}
                </div>
            </div>
        </>
    )
}



export default Dashboard